module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Medium.e2292c94.woff2";